import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=0bc63fa0&scoped=true&lang=pug&"
import script from "./SchoolInfo.vue?vue&type=script&lang=js&"
export * from "./SchoolInfo.vue?vue&type=script&lang=js&"
import style0 from "./SchoolInfo.vue?vue&type=style&index=0&id=0bc63fa0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc63fa0",
  null
  
)

export default component.exports